import axios from 'axios'

import { getToken } from '~/net'

export interface DownloadContractRequest {
  brand: string
  subscriptionId?: string
  accountId?: string
}

export interface DownloadContractResponse {
  contract: string
}

class DownloadContractService {
  constructor(private apiGateway: string) {}

  public async downloadContract(
    downloadContractRequest: DownloadContractRequest,
  ): Promise<DownloadContractResponse> {
    const { brand, subscriptionId, accountId } = downloadContractRequest
    return getToken().then((token) => {
      let authHeaders = {}

      if (token?.access_token !== 'NO_TOKEN_MOCK') {
        authHeaders = { authorization: `Bearer ${token.access_token}` }
      }

      return axios
        .get<DownloadContractResponse>(
          `${this.apiGateway}/customers/v7/orgs/${brand}/subscriptions/${subscriptionId}/contract`,
          {
            params: {
              accountId,
            },
            headers: {
              ...authHeaders,
            },
          },
        )
        .then((result) => result.data)
    })
  }
}

export default DownloadContractService
